import styled from "@emotion/styled/macro";
import { useRef } from "react";
import { publishMessage, useSubscribe } from "../../providers/Messages";
import { useAuthkey } from "../../providers/Auth";

const IFrameContainer = styled.iframe`
  width: 100%;
  height: 90vh;
  border: 1px solid #d0ccc3;
  border-radius: 16px;
  background: white;
`;

const PlaybookIframe = ({ src }: { src: string }) => {
  const ref = useRef<HTMLIFrameElement | null>(null);
  const authkey = useAuthkey();

  useSubscribe((message) => {
    const playbookWindow = ref.current?.contentWindow;

    // Send messages "upward" to the outer container.
    if (
      message.source !== "Auth" &&
      message.source !== "Container" &&
      message.source !== "Support"
    ) {
      publishMessage({ ...message, source: "Support" });
      return;
    }

    // Send messages "downward" to Playbook iframe.
    if (message.source === "Auth" || message.source === "Container") {
      if (playbookWindow) {
        playbookWindow.postMessage({ ...message, source: "Support" }, "*");
      }
    }
  });

  return (
    <IFrameContainer
      ref={ref}
      src={src}
      title="Playbook"
      onLoad={() => {
        const playbookWindow = ref.current?.contentWindow;
        if (!playbookWindow) return;

        if (authkey) {
          playbookWindow.postMessage(
            {
              source: "Support",
              type: "EVENT:AUTH_TOKEN",
              payload: { token: authkey },
            },
            "*"
          );
        }
      }}
    />
  );
};

export { PlaybookIframe };
